import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pb-10" }
const _hoisted_2 = {
  class: "anchor fw-bolder mb-5",
  id: "overview"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Overview ")
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" fully utilizes the ")
const _hoisted_6 = /*#__PURE__*/_createVNode("a", {
  href: "https://getbootstrap.com/docs/5.0/utilities/api/",
  class: "fw-bold"
}, "Bootstrap Utility API", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("  in ")
const _hoisted_8 = /*#__PURE__*/_createVNode("code", null, "src/sass/_utilities.scss", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" to generate additional utility classes to cover its own design system. The customized utility SASS variables are defined in ")
const _hoisted_10 = /*#__PURE__*/_createVNode("code", null, "src/sass/_variables.scss", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" and in ")
const _hoisted_12 = /*#__PURE__*/_createVNode("code", null, "src/sass/_variables.custom.scss", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" you can override any variable for your needs. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h1", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/documentation/utilities#overview" }),
      _hoisted_3
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("b", null, _toDisplayString(_ctx.themeName), 1),
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _hoisted_13
    ])
  ]))
}